import React from 'react';
import LoadingSpinner from './LoadingSpinner';
import { useTranslation } from 'react-i18next';

interface LoadingProps {
  tip?: string;
  size?: 'small' | 'default' | 'large';
  className?: string;
}

const Loading: React.FC<LoadingProps> = ({
  tip,
  size = 'large',
  className,
}) => {
  const { t } = useTranslation();
  const finalTip = tip ?? t('common.loading');
  return <LoadingSpinner tip={finalTip} size={size} className={className} />;
};

export default Loading;
